module.exports = __webpack_public_path__ + "img/39.567c4044.png";